import { MAX_CHAT_ATTACHMENT_BYTES, MAX_CHAT_BODY_LENGTH } from '@mfw/common';

export function getChatMessageInputIssue(
  body: string,
  files: readonly Pick<File, 'size'>[],
) {
  if (body.length > MAX_CHAT_BODY_LENGTH) return 'message-too-long';
  if (files.some((file) => file.size === 0)) return 'attachment-empty';
  if (files.some((file) => file.size > MAX_CHAT_ATTACHMENT_BYTES)) {
    return 'attachment-too-large';
  }
  return null;
}
